module.exports = __webpack_public_path__ + "img/arie_yes.1f35ded0.png";